import { call, put, select } from 'redux-saga/effects';
import UserClient from '../../api/UserClient';
import { profileIdSelector } from '../../selectors/user';
import { messagesShow } from '../../redux/messages/actions';
import { setSubscriptions, setSubscriptionsUpdating } from '../../redux/user/actions';

export default function* subscribeToAPlan({ payload }) {
    const { callback, planId } = payload;
    try {
        yield put(setSubscriptionsUpdating(true));

        const profileId = yield select(profileIdSelector);
        const data = {
            planId,
            profileId,
        };
        const currentSubscription = yield call(UserClient.subscribeToAPlan, data);

        yield put(setSubscriptions([currentSubscription]));
        yield put(messagesShow('subscriptionsSuccess', 'success'));
    } catch (error) {
        if (error && error.code && error.code === 409) {
            yield put(messagesShow('subscriptionsAlreadySubscribed', 'error'));
        } else {
            yield put(messagesShow('subscriptionsErrorMessage', 'error'));
        }
        console.error('[subscribeToAPlan]', error);
    } finally {
        yield put(setSubscriptionsUpdating(false));

        if (callback) {
            callback();
        }
    }
}
